import React from "react";
import Loader from "../../../../components/Loader";
import { Checkbox, Container, Stack, Button, Typography } from "@mui/material";
import { toast, ToastContainer } from 'react-toastify';
import Page from "../../../../components/Page";
import HTTPManager from "../../../../utils/httpRequestManager";
import MerchantDataGrid from '../DataGrid'; 
import AssignMenu from './assignMenu';
import AssignComponent from "./assignUser"; 
import MerchantReview from "./review";
import { checkButtonAccess } from "../../../../utils/protector";

export default class ReviewMerchants extends React.Component{
    httpManager = new HTTPManager();

    constructor(){
        super();
        this.state={
            isLoading:false,
            userdetail:{},
            merchantsList  :[],
            columns:[
                {
                    field: 'isDefault',
                    headerName: '',
                    minWidth: 50,
                    editable: false,
                    renderCell: (params) => (
                        <div> 
                          {/* disabled={params.row.AssignedTo != null}  */}
                            <Checkbox value={params.row.id}  disabled={params.row.assignedTo !== '' &&  params.row.assignedTo !== null && params.row.assignedTo !== undefined}  onChange={()=>this.addMerchanttoVerify(params.row)} checked={this.checkassign(params.row)}/>
                        </div>
                    )
                },
                  {
                    field: 'merchantName',
                    headerName: 'Business',
                    minWidth: 100, flex: 1,
                    editable: false,
                    renderCell: (params) => (
                      <div className="twoLineText" title={params.row.merchantName}>
                          {params.row.merchantName}
                      </div>
                    )
                  }, 
                  {
                    field: 'merchantEmail',
                    headerName: 'Email',
                    minWidth: 200, flex: 1,
                    editable: false,
                    renderCell: (params) => (
                      <div>
                          {params.row.merchantEmail}
                      </div>
                    )
                  },
                  {
                    field: 'merchantPhone',
                    headerName: 'Mobile',
                    minWidth: 150, flex: 1,
                    editable: false,
                    renderCell: (params) => (
                      <div>
                          {params.row.merchantPhone}
                      </div>
                    )
                  }, 
                  {
                    field: 'ownerName',
                    headerName: 'Owner Name',
                    minWidth:100, flex: 1,
                    editable: false,
                    renderCell: (params) => (
                      <div className="twoLineText" title={params.row.ownerName === '' || params.row.ownerName === null ? '--' : params.row.ownerName}>
                        {params.row.ownerName === '' || params.row.ownerName === null ? '--' : params.row.ownerName}
                      </div>
                    )
                  },
                  {
                    field: 'assignedto',
                    headerName: 'Assigned To',
                    minWidth:100, flex: 1,
                    editable: false,
                    renderCell: (params) => (
                      <div>
                        {params.row.assignedTo === null || params.row.assignedTo === undefined ? '--' : params.row.assignedTo}
                      </div>
                    )
                  },
                  {
                    field:'',
                    headerName:'Actions',
                    maxWidth:250,
                    minWidth:250, flex: 1,
                    editable: false,
                    renderCell: (params)=>(
                        <div>  
                            {((params.row.assignedTo!== null && params.row.assignedTo === '') || params.row.assignedTo === null || params.row.assignedTo === undefined) && ((checkButtonAccess('Merchant.Review.AssignToMe') === 'Y' || checkButtonAccess('Merchant.Review.AssignToStaff') === 'Y' || checkButtonAccess('Merchant.Review.AssignToMA') === 'Y' || checkButtonAccess('Merchant.Review.AssignToA') === 'Y') || (checkButtonAccess('Merchant.Review.AssignToMe') === 'W' || checkButtonAccess('Merchant.Review.AssignToStaff') === 'W' || checkButtonAccess('Merchant.Review.AssignToMA') === 'W' || checkButtonAccess('Merchant.Review.AssignToA') === 'W')) && <AssignMenu toVerify={this.state.merchantListToVerify} onClick={(key)=>{
                                this.setState({selectedMerchantId: params.row.id, merchantListToVerify:[]},()=>{ 
                                    this.selectAssignOption(key)
                                })
                            }} menuItems={this.getMenuItems(params)}/> } 
                            {( params.row.assignedTo !== null && params.row.assignedTo !== '' && params.row.assignedTo !== undefined && (this.state.userdetail.id === params.row.assignedUser || this.state.userdetail.userRole === 'SuperAdmin' || this.state.userdetail.userRole==='Master Agent')) &&<div >
                                            {(checkButtonAccess('Merchant.Review.Unassign') === 'Y' || checkButtonAccess('Merchant.Review.Unassign') === 'W' || checkButtonAccess('Merchant.Review.Unassign') === 'Y' || checkButtonAccess('Merchant.Review.Unassign') === 'W' || this.state.userdetail.userRole==='Master Agent') && <Button variant="contained" onClick={()=>{
                                                this.unassignUser(this.state.userdetail, params.row.id)
                                            }}>Un Assign</Button> }
                                            <Button variant="contained" onClick={()=>{
                                                this.onReviewMerchantDetail(params.row)
                                            }}>Review</Button>  
                                            </div>
                            }

                            {(params.row.assignedTo !== '' && params.row.assignedTo !== null && params.row.assignedTo !== undefined && this.state.userdetail.id !== params.row.assignedUser && this.state.userdetail.userRole !== 'SuperAdmin' && this.state.userdetail.userRole!=='Master Agent') &&<div style={{margin:'0 8px'}}>N/A</div>}

                        </div>
                    )
                  }
            ],
            merchantListToVerify: [],
            assignDialog: false,
            seletedUserType:'CN',
            selectedMerchantId:'',
            reviewMerchant: false,
            reviewMerchantDetail:{}
        }

        this.checkassign = this.checkassign.bind(this);
        this.addMerchanttoVerify = this.addMerchanttoVerify.bind(this);
        this.getMenuItems = this.getMenuItems.bind(this)
        this.selectAssignOption = this.selectAssignOption.bind(this);
        this.getSelectedUserType = this.getSelectedUserType.bind(this);
        this.assignUser = this.assignUser.bind(this);
        this.onReviewMerchantDetail = this.onReviewMerchantDetail.bind(this);
        this.onCloseReview = this.onCloseReview.bind(this);
    }

    componentDidMount(){
        var details  = window.localStorage.getItem('userdetail');
        if(details !== undefined && details !== null && details !== ''){
            this.setState({userdetail: JSON.parse(details)}, ()=>{
                this.reloadData();
            })
        } 
    }

    reloadData(msg=''){
        if(msg !== ''){
            toast.dismiss();
            toast.success(msg, {
                position: "top-center",
                autoClose: 5000,
                closeButton:false,
                hideProgressBar: true,
                closeOnClick: false,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
        }

        this.setState({isLoading: true, merchantListToVerify:[]}, ()=>{
            this.httpManager.postRequest(`merchant/getReviewMerchants`,{}).then(response=>{
               this.setState({merchantsList: response.data, isLoading:false});
            })

        })
    }

    addMerchanttoVerify(row){
        var merchants_verify = Object.assign([], this.state.merchantListToVerify);
        if(merchants_verify.indexOf(row.id) !== -1){
            let idx = merchants_verify.indexOf(row.id);
            merchants_verify.splice(idx, 1);
        }
        else{
            merchants_verify.push(row.id);
        }

        this.setState({merchantListToVerify:merchants_verify});
    }

    checkassign(row){
        if(this.state.merchantListToVerify.indexOf(row.id) !== -1){
            return true;
        }
        return false;
    }



    getMenuItems(params){
        var menuitems = []; 
            if(params.row.assignedTo === '' || params.row.assignedTo === null || params.row.assignedTo === undefined){
               if(checkButtonAccess('Merchant.Review.AssignToMe') === 'Y' || this.state.userdetail.userRole === 'SuperAdmin'){
                    menuitems.push({
                        Label:'Assign To Me',
                        value:"1"
                    })
                }
                if(checkButtonAccess('Merchant.Review.AssignToStaff') === 'Y' || this.state.userdetail.userRole === 'SuperAdmin'){
                    menuitems.push({
                        Label:'Assign To Staff',
                        value:"2"
                    })
                }
                if(checkButtonAccess('Merchant.Review.AssignToMA') === 'Y' || this.state.userdetail.userRole === 'SuperAdmin'){
                    menuitems.push({
                        Label:'Assign To Master Agents',
                        value:"3"
                    })
                }
                if(checkButtonAccess('Merchant.Review.AssignToA') === 'Y' || this.state.userdetail.userRole === 'SuperAdmin'){
                    menuitems.push({
                        Label:'Assign To Agents',
                        value:"4"
                    }) 
                }
            } 

       

        // menuitems.push({
        //     Label:'',
        //     value:""
        // })

        return menuitems;
    }

    selectAssignOption(key){
        if(key === '1'){ 
            this.setState({selectedUserType: this.state.userdetail.userType},()=>{
                var ids = [];
                if(this.state.merchantListToVerify.length>0){
                    ids = this.state.merchantListToVerify
                }
                else{
                    ids = [];
                    ids.push(this.state.selectedMerchantId);
                }
                this.assignUser(this.state.userdetail, ids)   
            })                        
        }
        else if(key === '2'){
            this.setState({selectedUserType:'CN'}, ()=>{
                this.setState({assignDialog: true})
            })
        }
        else if(key === '3'){
            this.setState({selectedUserType:'MA'}, ()=>{
                this.setState({assignDialog: true})
            })
        }
        else if(key === '4'){
            this.setState({selectedUserType:'A'}, ()=>{
                this.setState({assignDialog: true})
            })
        }
    }

    getSelectedUserType(){
        var usertype = '';
        switch(this.state.selectedUserType){
            case 'CN':  
                usertype = 'CN Employee'
                break;
            case 'MA':
                usertype = 'Master Agent';
                break;
            case 'A':
                usertype = 'Agent';
                break;
            default:
                usertype = 'CN Employee';
                break;
        }

        return usertype

    }


    assignUser(user, merchantids=[]){
        this.setState({assignDialog: false});
        var input = {
            userId: user.id,
            userType: this.state.selectedUserType,
            assignedTo: user.firstName+" "+user.lastName,
            merchantIds: merchantids
        }  
        //console.log(input)
        this.httpManager.postRequest(`/merchant/process/assignUser`, input).then(res=>{ 
            this.reloadData(res.message)
        })
    }


    unassignUser(user, merchantid){
        this.setState({assignDialog: false});
        var input = {
            userId: user.id, 
            merchantId: merchantid
        }  
        //console.log(input)
        this.httpManager.postRequest(`/merchant/process/unassignUser`, input).then(res=>{ 
            this.reloadData(res.message)
        })
    }

    onReviewMerchantDetail(detail){
        this.setState({reviewMerchantDetail:detail},()=>{
            this.setState({reviewMerchant: true})
        })
    }

    onCloseReview(){
        this.setState({reviewMerchantDetail:{}, reviewMerchant: false})
    }

    render(){
        return  <Page title="Review Merchant | Astro POS">
          {this.state.isLoading && <Loader />}
          <ToastContainer 
            position="top-center"
            autoClose={5000}
            hideProgressBar
            newestOnTop={false}
            closeOnClick={false}
            rtl={false}
            pauseOnFocusLoss={false}
            draggable={false}
            pauseOnHover={false}
            />  
        <Container maxWidth="xl">
        {!this.state.reviewMerchant && <><Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
            <Typography variant="h4" gutterBottom>
              Review Merchants
            </Typography> 

{this.state.userdetail.userRole === 'SuperAdmin' &&   <AssignMenu toVerify={this.state.merchantListToVerify.length > 0 ? [] : [ 
                                {
                                    Label:'Assign To Me',
                                    value:"1"
                                }] } onClick={(key)=>{
                                this.selectAssignOption(key)
                            }} menuItems={[ 
                                {
                                    Label:'Assign To Me',
                                    value:"1"
                                },
                                {
                                    Label:'Assign To Staff',
                                    value:"2"
                                },
                                {
                                    Label:'Assign To Master Agents',
                                    value:"3"
                                },
                                {
                                    Label:'Assign To Agents',
                                    value:"4"
                                }
                            ]}/> }

            </Stack>
            <MerchantDataGrid columns={this.state.columns} data={this.state.merchantsList} showAssignee={this.state.userdetail.userRole === 'SuperAdmin'||this.state.userdetail.userRole === 'Admin'}  assignees={[]}/>
                        </>}
            {this.state.assignDialog && <AssignComponent onClose={()=>{
                this.setState({selectedUserType:'CN', assignDialog: false, selectedMerchantId:'', merchantListToVerify:[]})
            }} selectedUserTypeKey={this.state.selectedUserType}  selectedUserType={this.getSelectedUserType()} onAssign={(user)=>{
                var ids = [];
                if(this.state.merchantListToVerify.length>0){
                    ids = this.state.merchantListToVerify
                }
                else{
                    ids = [];
                    ids.push(this.state.selectedMerchantId);
                }
                this.assignUser(user, ids)
            }} />} 

            {this.state.reviewMerchant && <MerchantReview showLoader={()=>{
                this.setState({isLoading: true})
            }} toReview={this.state.reviewMerchantDetail} closeReview={this.onCloseReview} reloadData={(msg='')=>{
                this.onCloseReview();
                this.reloadData(msg);
            }}/>}

            </Container>
        </Page>
    }
}